module.exports = __webpack_public_path__ + "static/media/icon_151.4bd18dbc.svg";